import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import { useProductContext } from '../ProductContext';
var ProductName = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var _ref$as = _ref.as,
      ElementType = _ref$as === void 0 ? 'span' : _ref$as,
      productFromProps = _ref.product,
      prefix = _ref.prefix,
      suffix = _ref.suffix,
      rest = _objectWithoutProperties(_ref, ["as", "product", "prefix", "suffix"]);

  var productFromContext = useProductContext();
  var product = productFromProps || productFromContext;
  return /*#__PURE__*/React.createElement(ElementType, _extends({
    "data-autotag": "grid-product-name",
    ref: ref
  }, rest), prefix && prefix, product.label, suffix && suffix);
});
ProductName.displayName = 'ProductName';
ProductName.propTypes = {
  /**
   * Element type to render. Defaults to a span.
   */
  as: PropTypes.elementType,

  /**
   * Adds extra output before the product label.
   */
  prefix: PropTypes.node,

  /**
   * Product. If none is passed, it will attempt to retrieve one from
   * ProductContext.
   */
  product: PropTypes.object,

  /**
   * Adds extra output after the product label.
   */
  suffix: PropTypes.node
};
export default ProductName;